import useCreateTaskFasterForward from '../mutations/useCreateTaskFasterForward';
import useExportPartyToFasterForward from '../mutations/useExportPartyToFasterForward';

export default function useActionsFasterForward() {
  const { mutateAsync: createTask } = useCreateTaskFasterForward();
  const { mutateAsync: exportParty } = useExportPartyToFasterForward();

  return {
    createTask,
    exportParty,
  };
}
